<template>
  <div :class="bindInputClass">
    <input
      id="uid-input"
      ref="uid-input"
      v-model="uidValue"
      autocomplete="off"
      :type="inputType"
      :inputmode="inpuTmode"
      :placeholder="placeholderText"
      @input="handleInput"
      @blur="handleBlur"
      @focus="handleFocus"
      @keyup.enter="handleBlur"
      :class="bindUidClass"
      :style="bindInputStyle"
    />
  </div>
</template>
<script>
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { inputUidManual, autoInputUid } from '@page_detail/firebase'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { storage } from '@/utils/storage'
  import { hexToRgba } from '@/utils/hexToRgba'
  import { chineseReg } from '@/utils/regExp'

  export default {
    mixins: [styleConfiguration],
    data() {
      return {
        inputmode: {
          tel: 'numeric',
          text: 'email',
        },
        uidValue: '', //UID
        errorCode: 200, // 报错code\显示特定的报错文案
      }
    },
    mounted() {
      this.getCacheUid()
    },
    computed: {
      ...mapState(['gameName', 'isDesktop', 'isMobile', 'region']),
      ...mapState('detail', ['serverList', 'checkffuid']),
      ...mapGetters([
        'firstCacheGamesKey',
        'selectedUidKey',
        'isNotCheckGames',
        'isAllExternalGames',
      ]),

      getFirstCacheGamesKey() {
        return storage.get(this.firstCacheGamesKey) || false
      },

      placeholderText() {
        return this.$t(`publicDetails.uid_placeholder`, {
          uid: 'UID',
        })
      },

      inputType() {
        return 'text'
      },

      inpuTmode() {
        return this.inputmode[this.inputType]
      },

      bindInputClass() {
        const defaultClass = ['not-input-uid']
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device.push(`${defaultClass[0]}-mobile`)
        }
        // 对于有serverList的数据、UID组件在【pc】不能100%展示
        // warn: FF的校验输入框 样式也一样
        if (this.serverList.length) {
          device.push(`${defaultClass[0]}-server`)
        }

        // 外部的CP、第一次会展示再次输入校验、【PC】不能100%展示
        if (this.isNotCheckGames && !this.getFirstCacheGamesKey) {
          device.push(`${defaultClass[0]}-first`)
        }

        return defaultClass.concat(device)
      },
      bindUidClass() {
        const classnames = ['input', this.gameName]
        let classTypes = []
        if (this.isDesktop) {
          classTypes.push('desktop-input')
        }
        return classnames.concat(classTypes)
      },

      bindInputStyle() {
        return {
          backgroundColor: this.skuBackColor.backgroundColor,
          borderColor: this.skuBackColor.borderColor,
          color: this.mFontColor.color,
          '--placeholderColor': hexToRgba(this.mFontColor.color),
        }
      },
    },
    watch: {},
    methods: {
      ...mapMutations(['detail/setUidValidator', 'detail/setUserId']),

      handleBlur() {
        // 如果不是第一次渲染的话 不校验
        if (this.getFirstCacheGamesKey) {
          this['detail/setUidValidator']()
        } else {
          if (this.checkffuid.trim() === '') {
            this['detail/setUidValidator']({ errorCode: 0, isError: false })
          }
          if (this.checkffuid !== this.uidValue) {
            this['detail/setUidValidator']({ errorCode: 200, isError: true })
          } else {
            this['detail/setUidValidator']({ errorCode: 0, isError: false })
          }
        }

        this['detail/setUserId'](this.uidValue)
        storage.set(this.selectedUidKey, this.uidValue)
      },
      getCacheUid() {
        const cacheUid = storage.get(this.selectedUidKey) || null
        if (!cacheUid) return

        this.uidValue = cacheUid

        // 如果是外部的SKU、那么直接注入VUEX、不进行check的校验
        this['detail/setUserId'](this.uidValue)
        storage.set(this.selectedUidKey, this.uidValue)
        autoInputUid(this.gameName)
      },

      handleFocus() {
        inputUidManual(this.gameName)
      },

      handleInput() {
        if (this.isAllExternalGames) {
          this.uidValue = this.uidValue.replace(chineseReg, '')
        }
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
